// Zentrale Debug-Konfiguration für die gesamte App
// Einfach DEBUG_MODE auf false setzen um alle Debug-Logs auszublenden

export const DEBUG_CONFIG = {
  // Haupt-Debug-Modus - steuert alle Debug-Logs
  DEBUG_MODE: false,

  // Spezifische Debug-Bereiche (können unabhängig gesteuert werden)
  AUTH_DEBUG: false, // Authentication & Subscription Logs
  AUTH_LOGIN_INFO_DEBUG: false, // Ausführliche Login-Infos (großes Banner)
  VIDEO_DEBUG: false, // Video Loading Logs
  API_DEBUG: false, // API Call Logs
  WORKSHOP_DEBUG: false, // Workshop Sync Logs

  // Performance-Monitoring
  PERFORMANCE_DEBUG: false, // Performance-bezogene Logs

  // Error-Logging (bleibt immer aktiv für echte Fehler)
  ERROR_LOGGING: true,
} as const;

// Hilfsfunktionen für bedingte Logs
export const debugLog = (...args: any[]) => {
  if (DEBUG_CONFIG.DEBUG_MODE) {
    console.log(...args);
  }
};

export const debugWarn = (...args: any[]) => {
  if (DEBUG_CONFIG.DEBUG_MODE) {
    console.warn(...args);
  }
};

export const debugError = (...args: any[]) => {
  if (DEBUG_CONFIG.ERROR_LOGGING) {
    console.error(...args);
  }
};

// Spezifische Debug-Funktionen für verschiedene Bereiche
export const authDebug = (...args: any[]) => {
  if (DEBUG_CONFIG.AUTH_DEBUG || DEBUG_CONFIG.DEBUG_MODE) {
    console.log("🔐 AUTH:", ...args);
  }
};

export const videoDebug = (...args: any[]) => {
  if (DEBUG_CONFIG.VIDEO_DEBUG || DEBUG_CONFIG.DEBUG_MODE) {
    console.log("🎬 VIDEO:", ...args);
  }
};

export const apiDebug = (...args: any[]) => {
  if (DEBUG_CONFIG.API_DEBUG || DEBUG_CONFIG.DEBUG_MODE) {
    console.log("🌐 API:", ...args);
  }
};

export const workshopDebug = (...args: any[]) => {
  if (DEBUG_CONFIG.WORKSHOP_DEBUG || DEBUG_CONFIG.DEBUG_MODE) {
    console.log("💃 WORKSHOP:", ...args);
  }
};

// Performance-Debug
export const perfDebug = (...args: any[]) => {
  if (DEBUG_CONFIG.PERFORMANCE_DEBUG || DEBUG_CONFIG.DEBUG_MODE) {
    console.log("⚡ PERF:", ...args);
  }
};

// Schnelle Toggle-Funktionen
export const toggleDebugMode = () => {
  DEBUG_CONFIG.DEBUG_MODE = !DEBUG_CONFIG.DEBUG_MODE;
  console.log(`Debug-Modus: ${DEBUG_CONFIG.DEBUG_MODE ? "AN" : "AUS"}`);
  return DEBUG_CONFIG.DEBUG_MODE;
};

export const enableAllDebug = () => {
  Object.keys(DEBUG_CONFIG).forEach(key => {
    if (key !== "ERROR_LOGGING") {
      (DEBUG_CONFIG as any)[key] = true;
    }
  });
  console.log("Alle Debug-Modi aktiviert");
};

export const disableAllDebug = () => {
  Object.keys(DEBUG_CONFIG).forEach(key => {
    if (key !== "ERROR_LOGGING") {
      (DEBUG_CONFIG as any)[key] = false;
    }
  });
  console.log("Alle Debug-Modi deaktiviert");
};
